import ReactGA from 'react-ga4'

const options = {}

const trackPage = page => {
  ReactGA.set({
    page,
    ...options
  })
  ReactGA.pageview(page)
}

let currentPage = ''

export const googleAnalytics = store => next => action => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    const nextPage = `${action.payload.location.pathname}${action.payload.location.search}`

    if (currentPage !== nextPage) {
      currentPage = nextPage
      trackPage(nextPage)
    }
  }

  if (action.type === 'USER_LOGGED_IN') {
    ReactGA.event({
      category: 'Login',
      action: 'User logged in',
      label: `${action.payload.currentUser.phone} - ${action.payload.currentUser.name}`
    })
  }

  if (action.type === 'SAVE_POSTED_SUBSIDIARY') {
    const userToken = store.getState().login.userToken
    const hotelName = action.payload.currentHotel.replace(/\s+/g, '-').toLowerCase()

    ReactGA.set({ userId: hotelName + userToken })

    ReactGA.event({
      category: 'Login',
      action: `Selected subsidiary`,
      label: action.payload.subsidiaryId
    })
  }

  if (action.type === 'GET_ANALYTICS_STARTED') {
    ReactGA.event({
      category: 'Analytics',
      action: 'Fetching analytics',
      label: `${action.payload.fromDate} - ${action.payload.toDate}`
    })
  }

  if (action.type === 'GOT_ACTIVE_GUESTS') {
    ReactGA.event({
      category: 'GuestList',
      action: 'Fetching active guests'
    })
  }

  if (action.type === 'GOT_ALL_GUESTS') {
    ReactGA.event({
      category: 'GuestList',
      action: 'Fetching all guests'
    })
  }

  if (action.type === 'GOT_REVIEW_REQUESTS') {
    ReactGA.event({
      category: 'Reviews',
      action: 'Fetching reviews list'
    })
  }

  if (action.type === 'GOT_DAILY_REVIEWS') {
    ReactGA.event({
      category: 'Reviews',
      action: 'Fetching daily reviews'
    })
  }

  if (action.type === 'GOT_UPLOAD_LOGS') {
    ReactGA.event({
      category: 'UploadLogs',
      action: 'Fetching upload logs'
    })
  }

  if (action.type === 'UPLOADED_GUEST_DATA') {
    ReactGA.event({
      category: 'UploadLogs',
      action: 'Uploaded guest data'
    })
  }

  if (action.type === 'GOT_CAMPAIGNS') {
    ReactGA.event({
      category: 'ManageCampaigns',
      action: 'Fetching campaigns'
    })
  }

  if (action.type === 'SENDING_TEST_TEXT') {
    ReactGA.event({
      category: 'ManageCampaigns',
      action: `SendingTestText`,
      label: action.payload.campaign
    })
  }

  if (action.type === 'GOT_INVOICES') {
    ReactGA.event({
      category: 'Invoices',
      action: `Fetching all invoices`
    })
  }

  if (action.type === 'GET_SINGLE_INVOICE_STARTED') {
    ReactGA.event({
      category: 'Invoices',
      action: `Viewing a statement`,
      label: `invoiceId: ${action.payload.invoiceId}`
    })
  }

  return next(action)
}
